import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function MethodIntro() {
  return <section className="py-16 px-4 bg-slate-900 text-white" data-id="element-91">
      <div className="max-w-4xl mx-auto" data-id="element-92">
        <div className="text-center mb-12" data-id="element-93">
          <span className="text-5xl mb-6 block" data-id="element-94">💡</span>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-6" data-id="element-95">
            Presentamos el MÉTODO CALMA®
          </h2>
          <p className="text-xl md:text-2xl text-slate-300 font-medium max-w-2xl mx-auto" data-id="element-96">
            Un sistema completo de guías prácticas diseñado para madres reales,
            en situaciones reales.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-97">
          <div className="bg-slate-800/50 rounded-2xl p-8 border border-slate-700" data-id="element-98">
            <h3 className="text-xl font-bold text-slate-400 mb-6 uppercase tracking-wider" data-id="element-99">
              Lo que NO es:
            </h3>
            <ul className="space-y-4" data-id="element-100">
              <li className="flex items-start gap-3" data-id="element-101">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-102" />
                <span className="text-slate-300" data-id="element-103">
                  No es un libro de teoría que nunca vas a terminar.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-104">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-105" />
                <span className="text-slate-300" data-id="element-106">
                  No es un podcast de 40 minutos que no tenés tiempo de
                  escuchar.
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-107">
                <XIcon className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-108" />
                <span className="text-slate-300" data-id="element-109">
                  No es otro consejo de "respirá profundo" que ya sabés y no te
                  alcanza.
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-green-900/20 rounded-2xl p-8 border border-green-500/30 relative overflow-hidden" data-id="element-110">
            <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 blur-3xl rounded-full" data-id="element-111" />
            <h3 className="text-xl font-bold text-green-400 mb-6 uppercase tracking-wider" data-id="element-112">
              Lo que SÍ es:
            </h3>
            <div className="flex items-start gap-3" data-id="element-113">
              <CheckIcon className="w-8 h-8 text-green-400 flex-shrink-0 mt-1" data-id="element-114" />
              <p className="text-xl font-bold text-white leading-relaxed" data-id="element-115">
                Es un sistema de herramientas concretas, cortas y aplicables en
                el momento exacto en que las necesitás.
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-16" data-id="element-116">
          <h3 className="text-3xl font-black text-center mb-12" data-id="element-117">
            Así de simple funciona
          </h3>

          <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-118">
            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-119">
              <div className="text-5xl mb-6" data-id="element-120">📖</div>
              <h4 className="text-xl font-bold text-yellow-400 mb-4" data-id="element-121">
                Abrís la guía
              </h4>
              <p className="text-slate-300" data-id="element-122">
                Sin complicaciones. Sin preparar nada. Listo en segundos.
              </p>
            </div>

            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-123">
              <div className="text-5xl mb-6" data-id="element-124">👆</div>
              <h4 className="text-xl font-bold text-yellow-400 mb-4" data-id="element-125">
                Elegís la herramienta
              </h4>
              <p className="text-slate-300" data-id="element-126">
                Técnicas diseñadas para cada situación: rabietas, rutinas,
                límites y más.
              </p>
            </div>

            <div className="bg-slate-800/30 p-8 rounded-2xl border border-slate-800" data-id="element-127">
              <div className="text-5xl mb-6" data-id="element-128">❤️</div>
              <h4 className="text-xl font-bold text-yellow-400 mb-4" data-id="element-129">
                Recuperás la calma
              </h4>
              <p className="text-slate-300" data-id="element-130">
                Sin gritos. Sin culpa. Solo vos y tus hijos, conectando de
                verdad.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}